<div class="app-page-card app-stack app-max-w-4xl app-mx-auto">
  <h1>Create Closer Document</h1>
  <p class="app-muted">
    Generate a branded PDF closer document — a single-property ROI analysis or a
    multi-property portfolio summary — from a valuation Excel file.
  </p>

  <div class="app-form-grid">
    <div class="app-field">
      <span>Client/Company Name</span>
      <calcite-input
        type="text"
        placeholder="Prospect's company or contact name"
        [value]="clientName()"
        (input)="setClientName($any($event.target).value)"
        [disabled]="generating()"
        autocomplete="off"
      ></calcite-input>
    </div>

    <div class="app-field">
      <span>Your Full Name</span>
      <calcite-input
        type="text"
        [value]="repName()"
        (input)="setRepName($any($event.target).value)"
        [disabled]="generating()"
        autocomplete="off"
      ></calcite-input>
    </div>

    <div class="app-field">
      <span>Your Title</span>
      <calcite-input
        type="text"
        [value]="repTitle()"
        (input)="setRepTitle($any($event.target).value)"
        [disabled]="generating()"
        autocomplete="off"
      ></calcite-input>
    </div>

    <div class="app-field">
      <span>Your Email</span>
      <calcite-input
        type="email"
        [value]="repEmail()"
        (input)="setRepEmail($any($event.target).value)"
        [disabled]="generating()"
        autocomplete="off"
      ></calcite-input>
    </div>

    <div class="app-field">
      <span>Paramount Fee %</span>
      <calcite-input-number
        placeholder="e.g. 25"
        [value]="feePct().toString()"
        (input)="setFeePct($any($event.target).value)"
        [disabled]="generating()"
        min="0"
        max="100"
      ></calcite-input-number>
    </div>

    <div class="app-field">
      <span>Document Type</span>
      <calcite-select [value]="documentType()" (calciteSelectChange)="setDocumentType($any($event.target).value)">
        <calcite-option value="single_property">Single Property</calcite-option>
        <calcite-option value="multi_property">Multi-Property</calcite-option>
      </calcite-select>
    </div>
  </div>

  <div class="app-field">
    <span>Valuation Document (.xlsx)</span>
    <app-file-drop-zone
      [accept]="['.xlsx']"
      documentType="Valuation Document"
      (fileSelected)="onFileSelected($event)"
    />
  </div>

  @if (isMultiProperty() && !scoutResults()) {
    <div class="app-button-row">
      <calcite-button
        appearance="solid"
        scale="m"
        [disabled]="!canPreview()"
        [loading]="scoutLoading()"
        (click)="previewProperties()"
      >
        Submit
      </calcite-button>
    </div>
  }

  @if (scoutResults(); as properties) {
    <div class="app-stack">
      <span class="app-eyebrow">Valuation Method Per Property</span>
      <table class="app-table-calcite app-table-nowrap">
        <thead>
          <tr>
            <th>Property</th>
            <th>Assessed Value</th>
            <th>Income Value</th>
            <th>Sales Value</th>
            <th>Method</th>
          </tr>
        </thead>
        <tbody>
          @for (property of properties; track property.property_index) {
            <tr>
              <td>{{ property.label }}</td>
              <td>{{ property.assessed_value | currency: 'USD' : 'symbol' : '1.0-0' }}</td>
              <td>
                {{
                  property.income_value !== null
                    ? (property.income_value | currency: 'USD' : 'symbol' : '1.0-0')
                    : '—'
                }}
              </td>
              <td>
                {{
                  property.sales_value !== null
                    ? (property.sales_value | currency: 'USD' : 'symbol' : '1.0-0')
                    : '—'
                }}
              </td>
              <td>
                <calcite-select
                  scale="s"
                  class="method-select"
                  [value]="methodSelectionFor(property.property_index) ?? ''"
                  (calciteSelectChange)="setMethodSelection(property.property_index, $any($event.target).value)"
                >
                  @if (property.income_value !== null) {
                    <calcite-option value="income">Income</calcite-option>
                  }
                  @if (property.sales_value !== null) {
                    <calcite-option value="sales">Sales</calcite-option>
                  }
                </calcite-select>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if (apiError()) {
    <p class="app-error">{{ apiError() }}</p>
  }

  @if (!isMultiProperty() || scoutResults()) {
    <div class="app-button-row">
      <calcite-button
        kind="brand"
        appearance="solid"
        scale="m"
        [disabled]="!canGenerate()"
        [loading]="generating()"
        (click)="generateDocument()"
      >
        Generate Document
      </calcite-button>
    </div>
  }
</div>
